angular.module('checkout').service(
    'shippingVerification',
    [
        '$window',
        'rcmApiLibService',
        'rcmLoading',
        'geoCode3Stripped',
        function (
            $window,
            rcmApiLibService,
            rcmLoading,
            geoCode3Stripped
        ) {
            /**
             * Hacking DI for Promise
             */
            let Promise = $window.Promise;

            /**
             * self
             */
            let self = this;

            /**
             * fedex api url
             */
            let verificationApiUrl = 'https://app.relivinc.com/fedex/addressvalidation';

            /**
             * country object api url
             */
            let countryIsoApiUrl = '/api/resource/rcm-country/{id}';

            /**
             *  address verification check api url
             */
            let isRequiredApiUrl = '/api/resource/shipping-verification/{id}';

            /**
             * shippingAddressToVerify
             * @type {{}}
             */
            let shippingAddressToVerify = {};

            /**
             * Api timeout
             * @type {number}
             */
            let validationTimeout = 5000;

            /**
             *
             * @param requestAddress
             * @returns {Promise}
             */
            self.getVerifiedShippingAddress = function (requestAddress) {

                let address = angular.copy(requestAddress);

                return isRequiredForCurrentCountry(address).then(
                    function (response) {
                        if (!response.data.verificationRequired) {
                            return new Promise(
                                function (resolve, reject) {
                                    reject('Can not verify');
                                }
                            );
                        }

                        return getCountryIsoApi(
                            address.country
                        );
                    }
                ).then(
                    function (response) {
                        address.countryIso2 = response.data.iso2;

                        return getVerifiedAddress(
                            address
                        );
                    }
                ).then(
                    function (response) {
                        let currentAddress = angular.copy(address);
                        delete currentAddress.countryIso2;
                        let verifiedEffectiveAddress = effectiveAddressDataPrep(address, response);

                        return new Promise(
                            function (resolve, reject) {
                                if (checkIfAddressesEqual(verifiedEffectiveAddress, currentAddress)) {
                                    reject('Can not verify, address is same');
                                    return;
                                }

                                if (response.data.State != 'NORMALIZED' && response.data.State != 'STANDARDIZED') {
                                    reject('Can not verify, address is not NORMALIZED or STANDARDIZED');
                                    return;
                                }

                                resolve(verifiedEffectiveAddress);
                            }
                        );
                    }
                ).then(
                    function (verifiedEffectiveAddress) {
                        return getAvailableGeoCodes(verifiedEffectiveAddress);
                    }
                );
            };

            /**
             * effectiveAddressDataPrep
             * @param address
             * @param response
             * @returns {*}
             */
            let effectiveAddressDataPrep = function (address, response) {
                //earlier we added so we can use it to post to fedex api
                delete address.countryIso2;
                address.addressLine1 = response.data.EffectiveAddress.StreetLines[0];
                //use address line 2 entered, if fedex return nothing
                address.addressLine2 = (response.data.EffectiveAddress.StreetLines[1] === undefined ) ? address.addressLine2 : response.data.EffectiveAddress.StreetLines[1];
                address.city = response.data.EffectiveAddress.City;
                address.state = response.data.EffectiveAddress.StateOrProvinceCode;
                address.postalCode = response.data.EffectiveAddress.PostalCode;

                return address;
            };

            /**
             * checkIfAddressesEqual
             * @param verifiedAddress
             * @param currentAddress
             * @returns boolean
             */
            let checkIfAddressesEqual = function (verifiedAddress, currentAddress) {
                return angular.equals(verifiedAddress, currentAddress);
            };

            /**
             * getVerifiedAddress
             * @param address
             * @returns {Promise}
             */
            let getVerifiedAddress = function (address) {
                let fetchPromise = fetchVerifiedAddress(address);

                let timeoutPromise = new Promise(
                    function (resolve, reject) {
                        let timeout = $window.setTimeout(
                            function () {
                                $window.clearTimeout(timeout);
                                reject('Address validation API timeout after: ' + validationTimeout);
                            },
                            validationTimeout
                        );
                    }
                );

                return Promise.race(
                    [
                        fetchPromise,
                        timeoutPromise,
                    ]
                );
            };

            /**
             * fetchVerifiedAddress
             * @param address
             * @returns {Promise}
             */
            let fetchVerifiedAddress = function (address) {
                let currentAddress = angular.copy(address);

                let addressToSend = prepEnteredShippingAddress(currentAddress);

                return rcmApiLibService.post(
                    {
                        url: verificationApiUrl,
                        data: addressToSend,
                        loading: function (loading) {
                            let loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                'shippingVerification.getVerifiedShippingAddress.loading',
                                loadingInt
                            );
                        },
                    }
                );
            };

            /**
             * getEnteredShippingAddress
             *
             * prepare ship address for fedex api format
             *
             * @param shipAddress
             */
            let prepEnteredShippingAddress = function (shipAddress) {

                shippingAddressToVerify = {
                    'StreetLines': [shipAddress.addressLine1, shipAddress.addressLine2],
                    'City': shipAddress.city,
                    'StateOrProvinceCode': shipAddress.state,
                    'PostalCode': shipAddress.postalCode,
                    'CountryCode': shipAddress.countryIso2,
                };

                return shippingAddressToVerify;
            };

            /**
             * getCountryIso
             *
             * @param countryCode
             * @param success
             * @param error
             * @returns {Promise}
             */
            let getCountryIsoApi = function (countryCode, success, error) {

                return rcmApiLibService.get(
                    {
                        url: countryIsoApiUrl,
                        urlParams: {id: countryCode},
                        loading: function (loading) {
                            let loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                'shippingVerification.getCountryIso.loading',
                                loadingInt
                            );
                        },
                    }
                );
            };

            /**
             * isRequiredForCurrentCountry
             *
             * @param addressToSend
             * @param success
             * @param error
             * @returns {Promise}
             */
            let isRequiredForCurrentCountry = function (addressToSend, success, error) {
                self.addressToSend = addressToSend;

                return rcmApiLibService.get(
                    {
                        url: isRequiredApiUrl,
                        urlParams: {id: 'current'},
                        loading: function (loading) {
                            let loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                'shippingVerification.getCountryIso.isRequiredForCurrentCountry',
                                loadingInt
                            );
                        },
                    }
                );
            };

            /**
             * getAvailableGeoCodes
             * @param address
             * @returns {Promise}
             */
            let getAvailableGeoCodes = function (address) {

                rcmLoading.setLoading(
                    'shippingVerification.getAvailableGeoCodes',
                    0
                );

                address = angular.copy(address);

                return geoCode3Stripped.getGeoCodes(
                    {
                        'filter[where][zip]': address.postalCode,
                        'filter[where][city]': address.city,
                        'filter[where][state]': address.state,
                    }
                ).then(
                    function (response) {
                        address.availableGeoCodes = response.data;

                        let currentGeoCode = null;

                        for (let i = 0; i < address.availableGeoCodes.length; i++) {
                            if (address.availableGeoCodes[i].geoCode === address.geoCode) {
                                currentGeoCode = address.availableGeoCodes[i];
                                break;
                            }
                        }

                        if (!currentGeoCode) {
                            address.geoCode = null;
                        }

                        rcmLoading.setLoading(
                            'shippingVerification.getAvailableGeoCodes',
                            1
                        );

                        return new Promise(
                            function (resolve, reject) {
                                resolve(address);
                            }
                        );
                    }
                ).catch(
                    function (err) {
                        rcmLoading.setLoading(
                            'shippingVerification.getAvailableGeoCodes',
                            1
                        );

                        return new Promise(
                            function (resolve, reject) {
                                reject('getAvailableGeoCodes failed');
                            }
                        );
                    }
                );
            };
        },
    ]
);
